<app-data-grid-comp
    [gridId]="gridId"
    [columns]="columns"
    category="PendingTimeOffRequests"
    [filterCategories]="filterCategories"
    [sort]="sort"
    [sortableColumns]="sortableColumns"
    [sortable]="{
        mode: 'multiple'
    }"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    clickableRows="true"
    hideActionButtons="true"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    export="excel"
    (emitOpenDialogEvent)="navigateToOrganization($event)"
    (emitGridStateChangeEvent)="gridStateChange($event)"
></app-data-grid-comp>